import script from "./Poster.vue?vue&type=script&lang=ts&setup=true"
export * from "./Poster.vue?vue&type=script&lang=ts&setup=true"

import "./Poster.vue?vue&type=style&index=0&id=221fc660&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-221fc660"]])

export default __exports__